<template>
  <div class="floating-back-button" @click="onClick()">
    <arrow-left-circle-icon style="color:rgba(50, 50, 50, 0.5)" stroke-width="1" size="34px"/>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ArrowLeftCircleIcon } from 'tdesign-icons-vue-next';
const router = useRouter();

const onClick = () => {
  router.back();
};
</script>

<style scoped>
.floating-back-button {
  position: fixed;
  top: 28px;
  right: 20px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;
}

.floating-back-button:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>